import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/navigation';
import type { NavigationActionPayloadVariants } from '@atlaskit/teams-app-config/types';
import { getMeta } from '@atlassian/eoc-fetch';
import { useIsNewNavigation } from '@atlassian/eoc-global-context';

export const useNavigateToTeamsApp = () => {
	const userHasNav4Enabled = useIsNewNavigation();

	return (action: NavigationActionPayloadVariants) =>
		navigateToTeamsAppBase({
			userHasNav4Enabled: userHasNav4Enabled,
			cloudId: getMeta('ajs-cloud-id') || '',
			hostProduct: 'jira',
			...action,
		});
};
